import { usePage } from '../../contexts'
import { Container } from './styles'

export type LogonProps = {
  centerImage?: boolean;
}

const Logo = ({ centerImage = false }:LogonProps) => {
  const { logo } = usePage()

  return <Container style={{ objectPosition: centerImage ? 'center' : 'left' }} src={logo}/>
}

export default Logo
